import "@servicetitan/anvil-fonts/dist/css/anvil-fonts.css";
import { ThemeProvider } from "../ThemeProvider";
import themeStyles from "../ThemeProvider/ThemeProvider.module.scss";
import { useMemo, useState } from "react";
import cx from "classnames";
import { useLayoutPropsUtil } from "../../internal/hooks";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useTranslations } from "../LocalizationProvider/useTranslations";
import { LocalizationContext } from "../LocalizationProvider";
import TrackingProvider from "../TrackingProvider";
import {
  AnvilProviderContext,
  AnvilProviderProps,
  TooltipLegacyGroupContext,
} from "./AnvilProviderContext";

export const AnvilProvider = (props: AnvilProviderProps) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);

  const {
    themeData,
    localizationData,
    trackingIdData,
    children,
    className,
    style,
    ...rest
  } = componentProps;

  const {
    locale = "en",
    dir = "ltr",
    translations = {},
  } = localizationData ?? {};

  const { scope = "ST", optOut } = trackingIdData ?? {};

  const classNameCombined = cx(className, [themeStyles["theme-core"]], {
    [themeStyles["mode-dark"]]: themeData?.mode === "dark",
    [themeStyles["mode-light"]]: themeData?.mode === "light",
  });
  const styleCombined = {
    ...style,
    ...layoutStyles,
  };

  const breakpoint = useBreakpoint();

  const [disableDelayGroup, setDisableDelayGroup] = useState(false);

  const { translations: t } = useTranslations(translations);

  const localizationContextValue = useMemo(() => ({ locale, t }), [locale, t]);
  const tooltipLegacyGroupContextValue = useMemo(
    () => ({ disableDelayGroup: setDisableDelayGroup }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disableDelayGroup],
  );

  return (
    <AnvilProviderContext.Provider value={{ breakpoint }}>
      <ThemeProvider
        className={classNameCombined}
        style={styleCombined}
        theme={themeData?.theme}
        mode={themeData?.mode}
        dir={dir}
        {...rest}
      >
        <TooltipLegacyGroupContext.Provider
          value={tooltipLegacyGroupContextValue}
        >
          <LocalizationContext.Provider value={localizationContextValue}>
            <TrackingProvider scope={scope} optOut={optOut}>
              {children}
            </TrackingProvider>
          </LocalizationContext.Provider>
        </TooltipLegacyGroupContext.Provider>
      </ThemeProvider>
    </AnvilProviderContext.Provider>
  );
};
